import {Stack} from '@mui/material';
import {Grid} from '@mui/material';
import {AppControlledInput} from 'components/form';
import React from 'react';
import {FieldsRendererProps} from './FieldsRenderer';

interface RenderEmailInputProps extends FieldsRendererProps {
    gridSize?: number;
}

export const RenderEmailInput: React.FC<RenderEmailInputProps> = ({field, control, baseFieldName, gridSize}) => {
    return (
        <Grid item md={gridSize} xs={12}>
            <Stack spacing={1}>
                <AppControlledInput
                    label={field.title}
                    fullWidth
                    placeholder={field.placeHolder}
                    control={control}
                    name={`${baseFieldName}.value`}
                    required={field.isRequired}
                    isEmail={true}
                />
            </Stack>
        </Grid>
    );
};

export default RenderEmailInput;
